// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__36L08","footer":"styles_footer__kGePz"};